/**
 * Badge — petite étiquette colorée (statut, rôle, département…).
 */
import { colors } from "../styles/tokens";

const VARIANTS = {
  default:  { bg: "rgba(138, 151, 176, 0.12)", color: colors.textMuted, border: "rgba(138, 151, 176, 0.25)" },
  gold:     { bg: colors.goldDim,              color: colors.goldLight, border: colors.goldBorder },
  success:  { bg: "rgba(45, 212, 160, 0.12)",  color: colors.green,     border: "rgba(45, 212, 160, 0.30)" },
  warning:  { bg: colors.goldDim,              color: colors.gold,      border: colors.goldBorder },
  danger:   { bg: "rgba(224, 91, 106, 0.12)",  color: colors.rose,      border: "rgba(224, 91, 106, 0.30)" },
  info:     { bg: "rgba(96, 165, 250, 0.12)",  color: colors.blue,      border: "rgba(96, 165, 250, 0.30)" },
};

const SIZES = {
  sm: { padding: "2px 8px",  fontSize: "11px", height: "20px" },
  md: { padding: "4px 10px", fontSize: "12px", height: "24px" },
  lg: { padding: "6px 14px", fontSize: "14px", height: "28px" },
};

/** Mappe le statut métier d'un membre à une variante. */
const STATUT_VARIANT = {
  actif:    "success",
  nouveau:  "gold",
  inactif:  "default",
  visiteur: "info",
};

export default function Badge({
  children,
  variant = "default",
  size = "md",
  statut = null,
  dot = false,
  style = {},
  ...rest
}) {
  const v = statut ? STATUT_VARIANT[statut] || "default" : variant;
  const palette = VARIANTS[v] || VARIANTS.default;
  const sizing = SIZES[size] || SIZES.md;

  const baseStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    background: palette.bg,
    color: palette.color,
    border: `1px solid ${palette.border}`,
    borderRadius: "999px",
    fontWeight: 600,
    letterSpacing: "0.02em",
    textTransform: "capitalize",
    whiteSpace: "nowrap",
    ...sizing,
    ...style,
  };

  return (
    <span style={baseStyle} {...rest}>
      {dot && (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: palette.color,
            display: "inline-block",
          }}
        />
      )}
      {children}
    </span>
  );
}
